import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DevFunctionCodePickerComponent } from '@shared/components/dev-function-code-picker/dev-function-code-picker.component';
import { NetworkStatusIndicatorComponent } from '@shared/components/network-status-indicator/network-status-indicator.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NetworkStatusIndicatorComponent,
    DevFunctionCodePickerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly _COMPONENT_NAME = 'AppComponent';

  constructor() {}
}
